import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import { TYPES } from 'constants/config';
import { hasGlobalFeature } from 'selectors';
import { modeSelectors } from 'selectors/pathBuilder';
import DueDateBadge from './DueDateBadge';
import EstimatedLessonCompletionTime from './EstimatedLessonCompletionTime';

const PathContentSubStep = ({
  features: { estimatedPathCompletionTime },
  editingMode,
  ...props
}) => (
  <div className="PathContentSubStep">
    <div className="PathContentSubStep-title d-f">
      {props.type === TYPES.LESSON && (
        <>
          <Icon name="lesson" className="PathContentSubStep-icon f-sh-0" />
          {(!estimatedPathCompletionTime || !editingMode) && (
            <span className="PathContentSubStep-title f-smooth">
              {props.title}
            </span>
          )}
          {estimatedPathCompletionTime && editingMode && (
            <div className="PathContentSubStep-completionTime f-smooth">
              <a
                href={props.urls.overview}
                target="_blank"
                rel="noreferrer noopener"
                className="u-linkBtn"
              >
                <span>{props.title}</span>
              </a>
              {props.estimatedMinutesToComplete && (
                <EstimatedLessonCompletionTime
                  additionalStyle={classNames('fz-base', {
                    'mr-8': props.dueIn,
                  })}
                  estimatedMinutesToComplete={props.estimatedMinutesToComplete}
                />
              )}
            </div>
          )}
        </>
      )}
      {props.type === TYPES.DEMONSTRATION && (
        <>
          <Icon name="link" className="PathContentSubStep-icon f-sh-0" />
          <span className="PathContentSubStep-title f-smooth">
            {t('demonstrations.singular')}:&nbsp;
            {props.title}
          </span>
        </>
      )}
    </div>
    {props.dueIn && <DueDateBadge {...props.dueIn} />}
    {props.stepNumber && (
      <div className="PathContentStep PathContentStep--innerStep">
        {props.stepNumber}
      </div>
    )}
  </div>
);

const mapStateToProps = state => ({
  editingMode: modeSelectors.isEdit(state.pathBuilder),
  features: {
    estimatedPathCompletionTime: hasGlobalFeature(
      state,
      'estimated_path_completion_time',
    ),
  },
});

export default connect(mapStateToProps)(PathContentSubStep);
